// Werkzeug-Registry fuer /tools. Hand-kuratierte Liste aus dem Backend
// (internal/tools/registry.go) -- aendert sich praktisch nie zur
// Laufzeit. 5-Min-Polling reicht; SWR sorgt fuer Instant-Paint bei
// Reload.

import { SvelteMap } from "svelte/reactivity";
import { registerRevalidator } from "./revalidate.svelte";

import { loadPersisted, persist } from "./persistent-summary.svelte";

export type ToolKind = "builtin" | "oberflaeche" | "agent" | "task" | "recovery" | "external";

export interface ToolEntry {
  id: string;
  name: string;
  description: string;
  kind: ToolKind;
  url?: string;
  host?: string;
  repo?: string;
  install_task?: string;
  task_id?: string;
  // rekey_host: gesetzt => die Card zeigt die Auto-Rekey-Fenster-Steuerung
  // fuer diesen SSH-Host (Host-Key aendert sich beim Flashen des Images).
  rekey_host?: string;
  // Oberflächen: wie man sich anmeldet ("Token", "Benutzer admin") und
  // unter welchem Namen das Passwort im Geheimnis-Speicher liegt.
  anmeldung?: string;
  geheimnis?: string;
}

const STORAGE_KEY = "tools";

const _state = new SvelteMap<string, ToolEntry[]>();
let _started = false;
let _timer: ReturnType<typeof setInterval> | undefined;

async function refresh(): Promise<void> {
  try {
    const r = await fetch("/v2-api/tools", { credentials: "include" });
    if (!r.ok) return;
    const list = (await r.json()) as ToolEntry[];
    _state.set("current", list);
    persist(STORAGE_KEY, list);
  } catch {
    /* ignore */
  }
}

export function startToolsSummary(): void {
  if (_started) return;
  _started = true;
  registerRevalidator(refresh);
  const cached = loadPersisted<ToolEntry[]>(STORAGE_KEY);
  if (cached) _state.set("current", cached);
  void refresh();
  _timer = setInterval(refresh, 5 * 60_000);
}

export function stopToolsSummary(): void {
  _started = false;
  if (_timer) {
    clearInterval(_timer);
    _timer = undefined;
  }
  _state.clear();
}

export function getToolsEntries(): ToolEntry[] | undefined {
  return _state.get("current");
}

export function refreshToolsSummary(): Promise<void> {
  return refresh();
}
